import { createMuiTheme } from '@material-ui/core/styles';

export const theme = {
  palette: {
    primary: {
      light: '#72e7ff',
      main: '#28b5f4',
      dark: '#0085c1',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#ff6090',
      main: '#e91e63',
      dark: '#b0003a',
      contrastText: '#ffffff',
    },
  },
};

export const muiTheme = createMuiTheme(theme);



// WEBPACK FOOTER //
// ./src/styles/theme.js